import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { HasProduct, withProduct } from "@insite/client-framework/Components/ProductContext";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { Typography } from "@insite/mobius/index";
import { TypographyPresentationProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import * as React from "react";

type Props = WidgetProps & HasProduct;

export interface ProductDetailsTierPricingLabelStyles {
    wrapper?: InjectableCss;
    label?: TypographyPresentationProps;
}

export const tierPricingLabelStyles: ProductDetailsTierPricingLabelStyles = {};

const styles = tierPricingLabelStyles;

const ProductDetailsTierPricingLabel: React.FC<Props> = ({ productInfo: { pricing }, productInfo }) => {
    if (!pricing?.unitRegularBreakPrices || pricing.unitRegularBreakPrices.length === 0) {
        return null;
    }

    return (
        <StyledWrapper {...styles.wrapper}>
            <Typography {...styles.label} data-test-selector="quantityBreakPricingLabel">
                {translate("See Quantity Discounts")}
            </Typography>
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: withProduct(ProductDetailsTierPricingLabel),
    definition: {
        displayName: "Tier Pricing Label",
        group: "Product Details",
        allowedContexts: ["ProductDetailsPage"],
    },
};

export default widgetModule;
